import React from 'react';
import { Card, Button, Avatar } from '@/components/ui';
import type { Company } from '../types/company.types';

interface CompanyProfileCardProps {
  company: Company;
  onEdit: () => void;
}

export function CompanyProfileCard({ company, onEdit }: CompanyProfileCardProps) {
  return (
    <Card className="p-6">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
        <div className="relative group">
          <Avatar 
            src={company.logo_path} 
            name={company.name} 
            size="lg" 
            className="w-24 h-24 rounded-2xl shadow-lg border-2 border-white ring-1 ring-slate-100"
          />
          <button className="absolute inset-0 bg-slate-900/60 text-white rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-xs font-bold">
            Thay đổi
          </button>
        </div>

        <div className="flex-1 text-center md:text-left space-y-2">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-bold text-slate-900">{company.name}</h2>
              <p className="text-sm text-slate-500 font-mono">ID: {company.code}</p>
            </div>
            <Button variant="outline" size="sm" icon="ri-edit-line" onClick={onEdit}>
              Chỉnh sửa thông tin
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 pt-2 text-sm">
            <div className="flex items-center gap-2 text-slate-600">
              <i className="ri-mail-line text-slate-400" />
              <span>{company.email || 'Chưa cập nhật email'}</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <i className="ri-phone-line text-slate-400" />
              <span>{company.phone || 'Chưa cập nhật SĐT'}</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <i className="ri-map-pin-line text-slate-400" />
              <span className="line-clamp-1">{company.address || 'Chưa cập nhật địa chỉ'}</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <i className="ri-global-line text-slate-400" />
              <span>{company.website || '---'}</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
